import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'momentCalendar'
})
export class MomentCalendarPipe implements PipeTransform {

  transform(value: number, args?: any): any {
    return moment(value).calendar(null, {
      sameDay: '[Today]',
      nextDay: '[Tomorrow]',
      nextWeek: 'MM/DD/YYYY',
      lastDay: '[Yesterday]',
      lastWeek: 'MM/DD/YYYY',
      sameElse: 'MM/DD/YYYY'
    });
  }

}
